if (!customElements.get('hpd-description')) {
  customElements.define('hpd-description', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const prose = this.querySelector('.hpd__prose');
      const excerpt = this.querySelector('.hpd__excerpt');
      const button = this.querySelector('button');
      const first = [...prose.querySelectorAll('p')].find(p => p.textContent.trim() && !p.closest('#hoyostar-product-details-sync, #hoyostar-description-ip-logo'));
      if (!first) return;
      excerpt.textContent = first.textContent.trim();
      excerpt.hidden = false;
      const needsPreview = [...prose.children].filter(e => getComputedStyle(e).display !== 'none').length > 1 || excerpt.scrollHeight > excerpt.clientHeight + 1;
      if (!needsPreview) { excerpt.hidden = true; return; }
      prose.hidden = true;
      button.hidden = false;
      button.textContent = button.dataset.more + ' +';
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        prose.hidden = !expanded;
        excerpt.hidden = expanded;
        button.textContent = (expanded ? button.dataset.less : button.dataset.more) + (expanded ? ' −' : ' +');
      });
    }
  });
}
